import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';
import {
  InvoiceNumberSyncStrategySchema,
  InvoicePaymentStatusSyncStrategySchema,
  TaxExportStrategySchema,
  AccountTaxItemSchema,
} from '@vy/integrations-types';

export const SYNC_DIRECTIONS = Object.freeze({
  SYNC_FROM_VAYU: 'sync-from-vayu',
  SYNC_TO_VAYU: 'sync-to-vayu',
  AUTO_SYNC_DISABLED: 'auto-sync-disabled',
});

export const XeroConfigurationFormSchema = oz.object({
  syncCustomer: oz.nativeEnum(SYNC_DIRECTIONS).optional(),
  syncApprovedInvoices: oz.boolean().optional(),
  invoiceNumberSyncStrategy: InvoiceNumberSyncStrategySchema.optional(),
  invoicePaymentStatusSyncStrategy: InvoicePaymentStatusSyncStrategySchema.optional(),
  autoExportCreditMemos: oz.boolean().optional(),
  defaultStripeDepositToAccountId: oz.string().nullish(),
  defaultDepositToAccountId: oz.string().nullish(),
  taxExportStrategy: TaxExportStrategySchema.optional(),
  accountTaxItem: AccountTaxItemSchema.optional(),
});

export type XeroConfigurationFormValues = oz.infer<typeof XeroConfigurationFormSchema>;
export type XeroConfigurationControl = Control<XeroConfigurationFormValues>;
